export const firstBreakpointName = 'mobile';
export const breakpointNames = [firstBreakpointName, 'mobileXl', 'tablet', 'desktop'];
export const breakpoints = {
    mobile: 0,
    mobileXl: 375,
    tablet: 768,
    desktop: 992,
};
export const isFirstBreakpoint = (b) => b === firstBreakpointName;
export const breakpointsDictMap = (f) => breakpointNames.reduce((c, b, i) => ({ ...c, [b]: f(b, i) }), {});
export const breakpointsDictInit = (a) => breakpointsDictMap(() => a);
export const isBreakpointBelowOrEqual = (a, t) => {
    const aIndex = breakpointNames.indexOf(a);
    const tIndex = breakpointNames.indexOf(t);
    return aIndex <= tIndex;
};
